var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"document-actions"},[_c('i',{staticClass:"si si-bin",attrs:{"title":"Delete"},on:{"click":function($event){_vm.deleteFavouriteById(_vm.id, _vm.$t('confirm_item_delete'))}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }